import styled from "@emotion/styled";

export const ModalWrapper = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: 1fr;
  width: 365px;
  height: fit-content;
  gap: ${({ theme }) => theme.space.space16};
  padding-block: ${({ theme }) => theme.space.space24};
  padding-inline: ${({ theme }) => theme.space.space16};

  .title-wrapper {
    display: flex;
    place-items: center;
    justify-content: space-between;

    h2 {
      display: flex;
      place-items: center;
      gap: ${({ theme }) => theme.space.space8};
      font-weight: 600;
    }
  }

  .content-wrapper {
    display: grid;
    gap: ${({ theme }) => theme.space.space16};

    .button-group {
      display: grid;
      gap: ${({ theme }) => theme.space.space8};
    }

    p > b {
      color: ${({ theme }) => theme.colors.tone.black};
      word-break: break-all;
    }
  }
`;
